<template>
    <div class="recommend-drawer">
        <div class="recommend-tieba-info">
            <div class="panel-item-wrap" @click.stop="goTiebaPage">
                <div class="panel-image">
                    <img :src="tiebaIcon" class="tieba-icon">
                </div>
                <div class="panel-info">
                    <div class="tieba-info">
                        <div class="tieba-info-name">百度贴吧</div>
                        <div v-if="rcDrawerInfo.download_tag" class="download-tag">
                            <div class="download-tag-text">{{ rcDrawerInfo.download_tag }}</div>
                        </div>
                    </div>
                    <div class="download-num">
                        {{ rcDrawerInfo.download_num }}人在百度贴吧下载了该游戏
                    </div>
                </div>
                <div
                    class="panel-btn"
                    @click.stop="goTiebaPage('btnClick')"
                >
                    <img :src="downloadTagIcon" class="btn-tag-icon">
                    <div class="btn-text">下载</div>
                </div>
            </div>
            <div
                v-if="rcDrawerInfo.tieba_threads.length > 0" class="chat-info"
                @click.stop="goTiebaPage"
            >
                <div
                    v-if="chat"
                    :class="['chat-info-chat', animStart ? 'chat-info-chat-anim' : '']"
                >
                    <img :src="chat.icon" class="chat-user-icon ">
                    <div class="detail" :style="{'max-width': '53.7vw'}">
                        {{ chat.title }}
                    </div>
                    <div class="num flex-style">
                        <img :src="likeIcon">
                        <span class="agree-num">{{ chat.agree_num }}</span>
                    </div>
                </div>
            </div>
            <div class="panel-bottom-line"></div>
            <div class="tieba-activity">
                <div
                    v-for="(item, index) in tiebaActivity" :key="index"
                    class="item-chat"
                >
                    <img :src="item.icon" class="item-icon">
                    <div class="item-text">{{ item.text }}</div>
                </div>
            </div>
        </div>
        <div v-if="rcDrawerInfo.is_show_four_element === 1" class="tieba-four-elements">
            <div class="panel-bottom-firm">
                <div class="firm">{{ rcDrawerInfo.dev }}</div>
                <div class="edition">v{{ rcDrawerInfo.version }}</div>
            </div>
            <div class="panel-bottom-right">
                <div class="privacy">
                    <!-- eslint-disable-next-line max-len -->
                    <span @click.stop="jumpPage(rcDrawerInfo.privacy)">隐私政策</span>和<span @click.stop="jumpPage(rcDrawerInfo.permission)">权限</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import {generateToken} from '@/utils/tiebaUtility';
import {copy} from '@/utils/browser';
import identifyIcon from 'public/assets/imgs/identify-icon.png';
import downloadTagIcon from 'public/assets/imgs/rec-dowload-drawer-tag.png';
export default {
    props: {
        rcDrawerInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            count: 0,
            animStart: false,
            identifyIcon: identifyIcon,
            downloadTagIcon: downloadTagIcon,
            likeIcon: 'https://gamedelivery.cdn.bcebos.com/comment/9a460c16eb7405e825f7958565efde0e.png',
            tiebaIcon: 'https://gamedelivery.cdn.bcebos.com/comment/82954dbd1dfc6c53da36047a694f7edf.png',
            tiebaActivity: [
                {
                    text: '实时群聊',
                    icon: 'https://gamedelivery.cdn.bcebos.com/comment/111361e118c735fe736c5f96facbc04c.png',
                },
                {
                    text: '组队陪玩',
                    icon: 'https://gamedelivery.cdn.bcebos.com/comment/85d5e50422a5ef3d0919f5a1d8c771d5.png',
                },
                {
                    text: '游戏礼包',
                    icon: 'https://gamedelivery.cdn.bcebos.com/comment/a1abe109e651eb12c3a73fa94366b62a.png',
                },
            ],
        };
    },
    computed: {
        chatIndex() {
            const len = this.rcDrawerInfo.tieba_threads?.length;
            if (!len) {
                return 0;
            }
            this.triggerAnim();
            return this.count % len;
        },
        chat() {
            return this.rcDrawerInfo.tieba_threads[this.chatIndex] || null;
        },
    },
    created() {
        setInterval(() => {
            this.count++;
        }, 3000);
    },
    methods: {
        jumpPage(url) {
            setTimeout(() => {
                location.href = url;
            }, 200);
        },
        closePanel() {
            this.$root.isShowTbFloatPanel = false;
        },
        triggerAnim() {
            if (this.rcDrawerInfo.tieba_threads.length > 1) {
                this.animStart = true;
            }
            setTimeout(() => {
                this.animStart = false;
            }, 600);
        },
        getToken(type) {
            if (type === 'btnClick') {
                const config = {
                    page: 'tbwebview',
                    param: {
                        obj_source: 'wise',
                        locate: 'outer_game_mfl',
                        track: 'test',
                        url: this.rcDrawerInfo?.act_url || '',
                    },
                };
                return generateToken(config);
            }
            const tid = this.rcDrawerInfo.tieba_threads?.[this.chatIndex]?.tid || '';
            const config = {
                page: 'pb',
                param: {
                    tid: tid,
                    extdata: {},
                    track: '',
                    locate: 'gamecenter',
                },
            };
            return generateToken(config);
        },
        goTiebaPage(type) {
            this.$root.sendLog('click', type === 'btnClick' ? 'AddBtnClick' : 'CarouselClick');
            const token = this.getToken(type);
            copy(token);
            // 下载按钮跳转下载活动页
            if (type === 'btnClick') {
                this.$root.report(token).then(() => {
                    TiebaNewWakeUp.init({
                        page: 'tbwebview',
                        param: {
                            obj_source: 'wise',
                            locate: 'outer_game_recommend',
                            url: encodeURIComponent(this.rcDrawerInfo?.act_url || ''),
                        },
                        androidShoubaiGoCenterPage: false,
                        androidDownUrl: this.rcDrawerInfo.download_url || '',
                    });
                });
            }
            // 轮播帖子跳转pb页
            else {
                const tid = this.rcDrawerInfo.tieba_threads?.[this.chatIndex]?.tid || '';
                this.$root.report(token).then(() => {
                    TiebaNewWakeUp.init({
                        page: 'pb',
                        param: {
                            tid: tid,
                            obj_source: 'wise',
                            locate: 'outer_game_joinqz',
                        },
                        androidShoubaiGoCenterPage: false,
                        androidDownUrl: this.rcDrawerInfo.download_url || '',
                    });
                });
            }
        },
    },
};

</script>

<style lang="scss" scoped>
@import "~@/common/style/mixin/utils";
.recommend-drawer {
    .recommend-tieba-info {
        background-image: linear-gradient(0deg, rgba(245,245,245,0.00) 0%, #F5F5F5 94%);
        border-radius: 36px;
        padding: 60px 60px 36px 60px;
        box-sizing: border-box;
        margin-bottom: 51px;
        .panel-item-wrap {
            display: flex;
            align-items: center;
            position: relative;
            margin-bottom: 25px;
            .panel-image {
                margin-right: 30px;
                .tieba-icon {
                    width: 160px;
                    height: 160px;
                    border: 1px solid rgba(0,0,0,0.06);
                    border-radius: 28px;
                }
            }
            .panel-info {
                margin-bottom: 7px;
                .tieba-info {
                    display: flex;
                    align-items: center;
                    margin-bottom: 30px;
                    .tieba-info-name {
                        font-family: PingFangSC-Medium;
                        font-size: 48px;
                        color: #1F1F1F;
                        line-height: 48px;
                        font-weight: 500;
                        margin-right: 18px;
                    }
                    .download-tag {
                        height: 48px;
                        background-image: url('https://gamedelivery.cdn.bcebos.com/comment/66ac3dc58d67f79cb15bec8ba46182bb.png');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        text-align: center;
                        padding: 9px 12px;
                        box-sizing: border-box;
                        .download-tag-text {
                            font-family: PingFangSC-Medium;
                            background-image: linear-gradient(0deg, #FFE9B8, #F4cc95);
                            -webkit-background-clip: text;
                            color: transparent;
                            font-size: 30px;
                            line-height: 36px;
                            font-weight: 500;
                        }
                    }
                }
                .download-num {
                    width: 578px;
                    font-family: PingFangSC-Regular;
                    font-size: 36px;
                    color: rgba(31,31,31,0.50);
                    line-height: 36px;
                    font-weight: 400;
                }
            }
            .panel-btn {
                width: 246px;
                height: 96px;
                line-height: 96px;
                background: #7559FF;
                color: #FFFFFF;
                border-radius: 47px;
                position: relative;
                text-align: center;
                font-size: 42px;
                margin-bottom: 7px;
                .btn-tag-icon {
                    width: 184px;
                    height: 42px;
                    position: absolute;
                    top: -21px;
                    right: 0;
                }
            }
        }
        .chat-info {
            width: 1000px;
            height: 97px;
            background: #F2F2F2;
            border-radius: 0px 49px 49px 49px;
            padding-left: 21px;
            &-chat {
                font-size: 39px;
                color: #858585;
                font-weight: 400;
                display: flex;
                align-items: center;
                user-select: none;
                line-height: 92px;
                &-anim {
                    position: relative;
                    animation: anim .2s linear;
                }
                .chat-user-icon {
                    width: 67px;
                    height: 67px;
                    margin-right: 9px;
                    border-radius: 50%;
                    line-height: 87px;
                    margin-bottom: 5px;
                }
                .detail {
                    margin: 0 24px 10px;
                    @include line-clamp1;
                }
                .num {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 5px;
                    img {
                        width: 39px;
                        margin-right: 10px;
                    }
                }
                @keyframes anim {
                    0% {
                        opacity: 0.5;
                        bottom: -20px;
                    }
                    100% {
                        opacity: 1;
                        bottom: 0;
                    }
                }
            }
        }
        .panel-bottom-line {
            width: 1020px;
            height: 2px;
            background: rgba(0,0,0,0.06);
            border-radius: 1px;
            margin: 60px 0 60px 0;
        }
        .tieba-activity {
            display: flex;
            align-items: center;
            font-family: PingFangSC-Regular;
            color: #1F1F1F;
            line-height: 42px;
            font-weight: 400;
            font-size: 42px;
            box-sizing: border-box;
            justify-content: space-between;
            .item-chat {
                display: flex;
                align-items: center;
                .item-icon {
                    width: 60px;
                    height: 60px;
                    margin-right: 12px;
                }
                .item-text {
                    opacity: 0.5;
                }
            }
        }
    }
    .tieba-four-elements {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: PingFangSC-Regular;
        font-size: 33px;
        color: #959BA4;
        line-height: 33px;
        font-weight: 400;
        .panel-bottom-firm {
            display: flex;
            align-items: center;
            .edition {
                margin-left: 10px;
            }
        }
        .panel-bottom-right {
            .privacy {
                margin-left: auto;
                z-index: 1001;
                span {
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>